import { NewClientEvaluationItem, NewClientEvaluationParams } from '@/typings/api/clueManage'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { AccountActivationParams } from '@/typings/api/customerCenter'

/**
 * ************************************** 新客评审/客户激活（接口共用，参数有别） **************************************
 */
//  获取新客评审列表数据
export function newClientEvaluationList(data?: NewClientEvaluationParams | AccountActivationParams) {
  return request.post<NewClientEvaluationItem, NewClientEvaluationItem>('/ofbu/api/oa/apply/page/list', data)
}
// 删除新客评审
export function newClientEvaluationDelete(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/delete', data)
}
// 新增新客评审
export function newClientEvaluationCreate(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/create', data, custom)
}
// 新增草稿
export function newClientEvaluationDraft(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/saveDraft', data, custom)
}
// 修改新客评审
export function newClientEvaluationEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/update', data)
}
// 新客评审详情
export function newClientEvaluationDetail(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/detail', data)
}
// 撤回新客评审
export function newClientEvaluationRetract(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/retract', data)
}
// 查询oa审核记录
export function newClientEvaluationReviewHistory(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/oa/apply/audit/list', data)
}
